<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <el-form inline class="search-header" :model="searchData">
      <el-form-item label="关键字" class="kw">
        <el-input
          placeholder="请输入"
          v-model="searchData.keywordValue"
          class="input-with-select"
          size="small"
        >
          <el-select
            v-model="searchData.keywordName"
            slot="prepend"
            placeholder="请选择"
            size="small"
            style="width: 150px"
          >
            <el-option
              v-for="item in searchTypeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item label="下次跟进日期">
        <el-date-picker
          style="width: 300px"
          size="small"
          v-model="searchData.nextFollowUpDateRange"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="流转时间">
        <el-date-picker
          style="width: 300px"
          size="small"
          v-model="searchData.transferTimeRange"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="分配状态">
        <el-select
          style="width: 180px"
          v-model="searchData.isKfAssigned"
          placeholder="请选择"
          size="small"
          clearable
        >
          <el-option label="未分配客服" :value="0"></el-option>
          <el-option label="已分配客服" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否特批">
        <el-select v-model="searchData.isForceApprove" placeholder="请选择" size="small" clearable>
          <el-option label="否" :value="false"></el-option>
          <el-option label="是" :value="true"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-button
          @click="getList"
          type="primary"
          icon="el-icon-search"
          size="small"
          >搜索</el-button
        >
        <el-button
          @click="reset"
          size="small"
          type="info"
          icon="el-icon-refresh"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-divider></el-divider>

    <div class="export-btn">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-download"
        @click="downloadExcel"
        >导出</el-button
      >
    </div>

    <tp-table
      :isCheckBox="false"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />

    <!-- 跟进记录组件 -->
    <FollowUpRecord
      :visible.sync="followUpRecordVisible"
      :order-info="currentOrder"
      :show-add-form="true"
      submit-button-text="提交"
      @success="handleFollowUpSuccess"
    />

    <!-- 订单流转组件 -->
    <OrderTransfer
      :visible.sync="orderTransferVisible"
      :order-no="currentOrderNo"
      :menu-type="1"
      @success="handleTransferSuccess"
    />

    <!-- 账单管理组件 -->
    <BillManage
      :visible.sync="billManageVisible"
      :order-no="billManageOrderNo"
      @success="getList"
    />
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import {
  exportAfterSaleOrderAPI,
  getAfterSaleOrderListAPI,
} from "../api/after-sale-order";
import { EnumAfterSaleMenuType } from "@/enum/dict/afterSaleOrder";
import FollowUpRecord from "../components/follow-up-record.vue";
import OrderTransfer from "../components/order-transfer.vue";
import BillManage from "../components/bill-manage.vue";
import { dateFormat } from "@/utils/index.js";
import { AfterSaleMenuTypeToFileNameMap } from "@/enum/dict/afterSaleOrder";

const columns = [
  {
    label: "客户信息",
    prop: "member",
    minWidth: "180",
    customRender(h, row) {
      return (
        <div>
          <div>姓名：{row["memberName"] || ""}</div>
          <div>手机号：{row["memberMobile"] || ""}</div>
        </div>
      );
    },
  },
  {
    label: "客服",
    prop: "kfUserName",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["kfUserName"] || ""}</p>;
    },
  },
  {
    label: "催收",
    prop: "dcUserName",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["dcUserName"] || ""}</p>;
    },
  },
  {
    label: "售后信息",
    prop: "afterSale",
    minWidth: "240",
    customRender(h, row) {
      return (
        <div>
          <div>售后状态：{row["order"]?.["afterSaleStatusName"] || ""}</div>
          <div>流转时间：{row["flowTime"] || ""}</div>
          <div>已流转：{row["flowDayNum"] || 0}天</div>
        </div>
      );
    },
  },
  {
    label: "跟进记录",
    prop: "followContent",
    minWidth: "240",
    customRender(h, row) {
      return (
        <div>
          <el-tooltip content={row["followContent"] || ""} placement="top">
            <div style="display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; text-overflow: ellipsis;">
              {row["followContent"] || ""}
            </div>
          </el-tooltip>
          <div style="color: #909399; font-size: 12px; margin-top: 5px">
            {row["followTime"] || ""}
          </div>
        </div>
      );
    },
  },
  {
    label: "下次跟进日期",
    prop: "nextFollowDate",
    minWidth: "150",
    customRender(h, row) {
      return <p>{row["nextFollowDate"] || ""}</p>;
    },
  },
  {
    label: "订单逾期天数",
    prop: "overdueDayNum",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["overdueDayNum"] || 0}</p>;
    },
  },
  {
    label: "商品信息",
    prop: "goods",
    minWidth: "250",
    customRender(h, row) {
      return (
        <div>
          <div>商品名称：{row["order"]?.["goodsTitle"] || ""}</div>
          <div>设备状态：{row["order"]?.["deviceStatusName"] || ""}</div>
          <div>
            锁机状态：
            <el-tag
              v-show={row["order"]["lockStatus"] == 0}
              type="success"
              size="mini"
            >
              未锁机
            </el-tag>
            <el-tag
              v-show={row["order"]["lockStatus"] == 1}
              type="warning"
              size="mini"
            >
              待锁机
            </el-tag>
            <el-tag
              v-show={row["order"]["lockStatus"] == 2}
              type="danger"
              size="mini"
            >
              已锁机
            </el-tag>
          </div>
        </div>
      );
    },
  },
  {
    label: "订单信息",
    prop: "order",
    minWidth: "260",
    customRender(h, row) {
      return (
        <div>
          <div>订单号：{row["orderNo"] || ""}</div>
          <div>下单时间：{row["order"]?.["createTime"] || ""}</div>
          <div>
            是否特批：
            <el-tag type={row["isForceApprove"] ? "success" : "info"} size="mini">
              {row["isForceApprove"] ? "是" : "否"}
            </el-tag>
          </div>
          <div>订单状态：{row["order"]?.["statusName"] || ""}</div>
        </div>
      );
    },
  },
  {
    label: "门店信息",
    prop: "store",
    minWidth: "200",
    customRender(h, row) {
      return (
        <div>
          <div>门店名称：{row["storeName"] || ""}</div>
          <div>门店跟进人：{row["storeBusinessUserName"] || ""}</div>
        </div>
      );
    },
  },
  {
    label: "审核",
    prop: "reviewUserName",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["reviewUserName"] || ""}</p>;
    },
  },
  {
    label: "操作",
    minWidth: "200",
    fixed: "right",
    customRender(h, row) {
      return (
        <div>
          <el-link
            underline={false}
            type="primary"
            style="margin-right: 10px"
            onClick={() => this.handleOrderDetail(row)}
          >
            订单详情
          </el-link>
          <el-link
            underline={false}
            type="primary"
            style="margin-right: 10px"
            onClick={() => this.handleOrderBill(row)}
          >
            账单
          </el-link>
          <el-link
            underline={false}
            type="primary"
            style="margin-right: 10px"
            onClick={() => this.handleContractDetail(row)}
          >
            合同凭证
          </el-link>
          <el-link
            underline={false}
            type="primary"
            style="margin-right: 10px"
            onClick={() => this.handleFollowUpRecord(row)}
          >
            跟进记录
          </el-link>
          <el-link
            underline={false}
            type="primary"
            style="margin-right: 10px"
            onClick={() => this.handleTransfer(row)}
          >
            移交
          </el-link>
          <el-link
              underline={false}
              type="primary"
              onClick={() => this.handleBillManage(row)}
          >
            账单管理
          </el-link>
        </div>
      );
    },
  }
];

export default {
  name: "CustomerServiceOverdue",
  mixins: [authBtnMixin],
  components: {
    FollowUpRecord,
    OrderTransfer,
    BillManage,
  },
  data() {
    return {
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        keywordName: "memberName",
        keywordValue: "",
        nextFollowUpDateRange: [],
        transferTimeRange: [],
        isKfAssigned: null,
        isForceApprove: null,
      },
      searchTypeOptions: [
        { name: "订单号", value: "orderNo" },
        { name: "客户姓名", value: "memberName" },
        { name: "手机号", value: "memberMobile" },
        { name: "客服", value: "kfUserName" },
        { name: "门店跟进人", value: "storeBusinessUserName" },
      ],
      followUpRecordVisible: false,
      orderTransferVisible: false,
      billManageVisible: false,
      billManageOrderNo: "",
      currentOrder: null,
      currentOrderNo: "",
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  methods: {
    buildParams(defaultParams = {}) {
      const params = {
        ...defaultParams,
        isKfAssigned: this.searchData.isKfAssigned,
        isForceApprove: this.searchData.isForceApprove,
        menuType: EnumAfterSaleMenuType.CUSTOMER_SERVICE_OVERDUE,
      };

      // 处理关键字搜索
      if (this.searchData.keywordName && this.searchData.keywordValue) {
        params[this.searchData.keywordName] = this.searchData.keywordValue;
      }

      // 处理下次跟进日期范围
      if (this.searchData.nextFollowUpDateRange) {
        params.leftNextFollowDate = this.searchData.nextFollowUpDateRange[0];
        params.rightNextFollowDate = this.searchData.nextFollowUpDateRange[1];
      }

      // 处理流转日期范围
      if (this.searchData.transferTimeRange) {
        params.leftFlowDate = this.searchData.transferTimeRange[0];
        params.rightFlowDate = this.searchData.transferTimeRange[1];
      }

      return params;
    },
    async getList() {
      const params = this.buildParams({
        page: this.currentPage,
        pageSize: this.pageSize,
      });

      const res = await getAfterSaleOrderListAPI(params);

      this.list = res.list || [];
      this.total = res.total || 0;
    },
    reset() {
      this.searchData = {
        keywordName: "memberName",
        keywordValue: "",
        orderNo: "",
        nextFollowUpDateRange: [],
        transferTimeRange: [],
        isKfAssigned: null,
        isForceApprove: null,
      };
      this.currentPage = 1;
      this.getList();
    },
    handleOrderDetail(row) {
      const link = this.$router.resolve({
        name: "OrderDetail",
        params: { id: row.order?.orderNo },
        query: {
          memberId: row.member?.id,
          orderType: row.order?.orderType,
        },
      });
      window.open(link.href, "_blank");
    },
    handleOrderBill(row) {
      const link = this.$router.resolve({
        name: "OrderBill",
        params: { id: row.order?.orderNo },
      });
      window.open(link.href, "_blank");
    },
    handleContractDetail(row) {
      const link = this.$router.resolve({
        name: "OrderContractDetail",
        params: { id: row.order?.orderNo },
      });
      window.open(link.href, "_blank");
    },
    handleFollowUpRecord(row) {
      this.currentOrder = row;
      this.followUpRecordVisible = true;
    },
    handleTransfer(row) {
      this.currentOrderNo = row.order?.orderNo || "";
      this.orderTransferVisible = true;
    },
    handleFollowUpSuccess() {
      this.getList();
    },
    handleTransferSuccess() {
      this.getList();
    },
    handleBillManage(row) {
      this.billManageOrderNo = (row.order ? row.order.orderNo : "") || row.orderNo || "";
      this.billManageVisible = true;
    },
    async downloadExcel() {
      const params = this.buildParams();
      const fileName = `果冻租${AfterSaleMenuTypeToFileNameMap.get(EnumAfterSaleMenuType.CUSTOMER_SERVICE_OVERDUE)}${dateFormat()}.xlsx`;
      exportAfterSaleOrderAPI(params, fileName);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
}

.search-header {
  .kw {
    ::v-deep {
      .input-with-select {
        vertical-align: middle;
      }
      .input-with-select .el-input-group__prepend {
        background-color: #fff;
      }
    }
  }
}

.export-btn {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
</style>
